<script>
  import { fade, fly } from "svelte/transition";
  import { getLocal, persist } from "../../../stores/store";
  let todos = [];
  let date = "";

  try {
    todos = getLocal("todos") || [];
  } catch (err) {
    todos = [];
  }

  const clearCompleted = () => {
    todos = todos.filter(todo => !todo.completed);
  };

  const removeTodo = id => {
    const idx = todos.findIndex(todo => todo.id === id);
    todos.splice(idx, 1);
    let updTodos = [...todos];
    localStorage.setItem("todos", JSON.stringify(updTodos));
    todos = updTodos;
    return todos;
  };

  $: numActive = todos.filter(todo => !todo.completed).length;
  $: numCompleted = todos.filter(todo => todo.completed).length;
  $: try {
    localStorage.setItem("todos", JSON.stringify(todos));
  } catch (err) {
    console.log(err);
  }
</script>

<style>
  .todos {
    background-color: rgb(255, 255, 255, 0.8);
    color: #494d4e;
    padding: 2em;
    display: grid;
    justify-content: stretch;
    border-radius: 5px;
    box-shadow: -5px 19px 38px rgba(0, 0, 0, 0.3),
      -5px 15px 12px rgba(0, 0, 0, 0.22);
    width: 100%;
  }

  .todosList {
    list-style-type: none;
    display: grid;
    grid-gap: 1em;
  }

  p {
    font-size: 2.2vh;
  }

  .row {
    width: 100%;
    display: grid;
    grid-template-columns: 20px auto 1fr 20px;
    justify-content: space-between;
    align-items: baseline;
  }

  .checkContainer {
    display: inline-block;
    position: relative;
  }

  .check {
    text-align: center;
    justify-self: flex-start;
    cursor: pointer;
    vertical-align: baseline;
  }

  .title {
    font-size: 1.2rem;
    font-weight: bold;
    margin-right: 2em;
  }

  .due {
    color: rgb(219, 17, 17);
    font-weight: bold;
    font-size: 0.8rem;
    justify-self: flex-end;
  }

  .completed {
    font-style: italic;
    text-decoration: line-through;
    color: rgb(73, 77, 78, 0.7);
  }

  .footer {
    margin-top: 1.5em;
    display: grid;
    grid-gap: 1vw;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
    align-items: flex-end;
  }

  .clear-completed {
    cursor: pointer;
    justify-self: flex-end;
    transition: all 0.2s linear;
    padding: 0;
    border: 0;
    background: none;
    position: relative;
    top: 8px;
    font-size: 2vh;
  }

  .clear-completed:hover {
    color: rgb(219, 17, 17);
  }

  .remove {
    grid-column: 4/-1;
    cursor: pointer;
    width: 35px;
    height: 30px;
    transition: all 0.2s ease-in;
    position: relative;
    border: none;
    align-self: center;
    top: 2px;
  }

  .remove:hover {
    border: none;
    filter: invert(0.2) sepia(1) hue-rotate(150deg) saturate(1.5) brightness(1);
  }
</style>

<div in:fade={{ duration: 700 }} class="todos">

  {#if todos.length > 0}
    <ul class="todosList">
      {#each todos as { id, title, desc, date, completed }}
        <li
          id="li"
          in:fly={{ y: -500, duration: 200, delay: 0 }}
          class={completed ? 'completed' : ''}>
          {#if date !== 'No Date'}
            <div class="row">
              <div class="checkContainer">
                <div class="check">
                  <input
                    bind:checked={completed}
                    class="check"
                    type="checkbox"
                    {id} />
                </div>
              </div>
              <span class="title">{title}</span>
              <p class="due">Due By: {date.slice(4)}</p>
              <img
                class="remove"
                on:click={removeTodo(id)}
                src="./images/delete.svg"
                alt="remove todo" />
            </div>
          {:else}
            <div class="row">
              <div class="checkContainer">
                <div class="check">
                  <input
                    bind:checked={completed}
                    class="check"
                    type="checkbox"
                    {id} />
                </div>
              </div>
              <span class="title">{title}</span>
              <img
                class="remove"
                on:click={removeTodo(id)}
                src="./images/delete.svg"
                alt="remove todo" />
            </div>
          {/if}
        </li>
      {/each}
    </ul>
  {:else}
    <p style="text-align: center;">You don't have any todos, go add some!</p>
  {/if}

  <footer class="footer">
    <p class="todo-count">
      <strong>{numActive}</strong>
      {numActive === 1 ? 'item' : 'items'} left
    </p>

    <button
      class="clear-completed"
      disabled={numCompleted === 0}
      on:click={clearCompleted}>
      Clear completed
    </button>

  </footer>

</div>
